<ct-loading></ct-loading>

<ct-consultant-header *ngIf="module === 'consultant'"></ct-consultant-header>
<ct-candidate-header *ngIf="module === 'candidate' || module === 'error'"></ct-candidate-header>

<main *ngIf="module !== 'report'" [class]="utilsService.feature === 'home' ? 'home-style' : ''">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</main>

<main *ngIf="module === 'report'" class="bg-secondary">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</main>
<ct-footer *ngIf="module === 'candidate' || module === 'error'" [clientId]="clientId"></ct-footer>
